import { required, regex, minLength, maxLength, minValue, maxValue } from "jazasoft";

// helpers
import { DataType } from "./types";
import { isEmpty } from "./helpers";

const getValidation = validation => {
  if (isEmpty(validation)) return [];

  let validateList = [];
  if (!(validation.required === false || validation.required === "false")) {
    validateList.push(required());
  }

  if (validation.dataType?.toLowerCase() === DataType.TEXT) {
    if (!isEmpty(validation.regex)) {
      validateList.push(regex(new RegExp(validation.regex), validation.regexError));
    }
    if (!isEmpty(validation.minLength)) {
      validateList.push(minLength(validation.minLength));
    }
    if (!isEmpty(validation.maxLength)) {
      validateList.push(maxLength(validation.maxLength));
    }
  }

  if (validation.dataType?.toLowerCase() === DataType.NUMBER) {
    if (!isEmpty(validation.minValue)) {
      validateList.push(minValue(validation.minValue));
    }
    if (!isEmpty(validation.maxValue)) {
      validateList.push(maxValue(validation.maxValue));
    }
  }
  return validateList;
};

export default getValidation;
